<div class="container">
    <div class="header">
        <div class="logo left">
            <img src="../../../assets/img/logo/time-tennis/logo.png" alt="">
        </div>
        <span style="font-weight: 900;">time tennis</span> international
        <div class="logo right">
            <img src="../../../assets/img/logo/time-tennis/logo.png" alt="">
        </div>
    </div>
    <div class="body">
        <div class="col">
            <div class="side">
                <div class="participant">
                    <div>TORONTO</div>
                    <div>
                        <img src="../../../assets/img/logo/time-tennis/toronto.png" alt="">
                    </div>
                    <div>
                        {{ getParticipantName(1, 1) }}
                        @if (match.matchType === 'D') {
                            <br />
                            {{ getParticipantName(1, 2) }}
                        }
                    </div>
                    <div class="score">
                        {{ match.score?.side1PointScore || 0 }}
                        <div class="server" [style.background-color]="server?.sideNumber === 1 ? '#8cc63e' : '#474140'"></div>
                    </div>
                </div>

            </div>
        </div>
        <div class="col">
            <div class="middle">
                <div class="stopwatch-row">
                    <div class="stopwatch">
                        <div class="label">
                            SERVE CLOCK
                        </div>
        
                        <div class="time">
                            <app-stopwatch [match]="match" [clockInputValue]="pointBreakTimer" [displayType]="'TIMED_TENNIS_SCOREBOARD'"></app-stopwatch>
                        </div>
                    </div>
                </div>
                <div class="stopwatch-row">
                    <div class="stopwatch">
                        <div class="label">
                            TIME
                        </div>
        
                        <div class="time">
                            <app-stopwatch [match]="match" [clockInputValue]="setTimer" [displayType]="'TIMED_TENNIS_SCOREBOARD'"></app-stopwatch>        
                        </div>
                    </div>
                </div>
    
                <div class="quarter-row">
                    <div class="quarter">
                        QTR: {{ match.score?.sets?.length || 0 }}
                    </div>
                </div>
            </div>

        </div>

        <div class="col">
            <div class="side">
                <div class="participant">
                    <div>MIAMI</div>
                    <div>
                        <img src="../../../assets/img/logo/time-tennis/miami.png" alt="">
                    </div>
                    <div>
                        {{ getParticipantName(2, 1) }}
                        @if (match.matchType === 'D') {
                            <br />
                            {{ getParticipantName(2, 2) }}
                        }                    </div>
                    <div class="score">
                        {{ match.score?.side2PointScore || 0 }}
                        <div class="server" [style.background-color]="server?.sideNumber === 2 ? '#8cc63e' : '#474140'"></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>